import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {  CreateSpecificationsResponse, SpecificationsAttribute, SpecificationsPayload } from '../../../../models/specifications';

@Injectable({
  providedIn: 'root'
})
export class SpecificationsService {

  constructor(private readonly _http: HttpClient) { }
  
  create(specifications: SpecificationsPayload[], categoryId: string, storeId: string): Observable<CreateSpecificationsResponse> {
    const url = `${environment.url}/management/category/v2/store/${storeId}/${categoryId}/spec-attributes`;
    return this._http.put<CreateSpecificationsResponse>(url, specifications);
  }

  remove(storeId: string, productId: string): Observable<void> {
    return this._http.delete<void>(`${environment.url}/management/product/v2/store/${storeId}/products/${productId}/specifications`)
  }
  getSpecificationsAttributes(): Observable<SpecificationsAttribute[]> {
     return this._http.get<SpecificationsAttribute[]>(`${environment.url}/management/category/v2/spec-attributes`);
   }
}
